import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/auth/AuthContext";
import { PublicLayout } from "@/components/PublicLayout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { ScrollManager } from "@/components/ScrollManager";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Servizi from "@/pages/Servizi";
import Azienda from "@/pages/Azienda";
import Contatti from "@/pages/Contatti";
import { PrivacyPolicy, CookiePolicy } from "@/pages/Legal";
import { Noleggio, Vendita } from "@/pages/Mobility";
import NotFound from "@/pages/NotFound";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function App() {
  return (
    <AuthProvider>
      <LanguageProvider>
        <BrowserRouter>
          <ScrollManager />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/servizi" element={<Servizi />} />
              <Route path="/azienda" element={<Azienda />} />
              <Route path="/contatti" element={<Contatti />} />
              <Route path="/privacy" element={<PrivacyPolicy />} />
              <Route path="/cookie" element={<CookiePolicy />} />
              <Route path="/noleggio-auto" element={<Noleggio />} />
              <Route path="/auto-in-vendita" element={<Vendita />} />
              <Route path="*" element={<NotFound />} />
            </Route>
            <Route path="/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
        <Toaster
          position="top-center"
          theme="dark"
          toastOptions={{ style: { background: "#15191E", border: "1px solid #2A313C", color: "#F4F7F8" } }}
        />
      </LanguageProvider>
    </AuthProvider>
  );
}

export default App;
